import React from 'react';
import styled from 'styled-components';
import {fontSize} from '../mixins';


const StyledUsername = styled.p`
   color: ${props => props.isDisabled ? '#9C9C9C' : '#323232'};
   font-weight: 700;
   ${fontSize(16)};
   line-height: 22px;
   letter-spacing: -0.313529px;
   margin: 7px 0;
   word-break: break-all;
   text-align: left;

   @media screen and (min-width: 768px) {
      ${fontSize(20)};
      line-height: 25px;
      text-align: left;
   }
`

const Username = (props) => (
    <StyledUsername isDisabled={props.isDisabled}>
        {props.children}
    </StyledUsername>
);


export default Username;